// What a stage change of the idle tracker means for the rest of the game (spec 2026-10-22).
// main.js runs the returned steps in order. Going inactive only matters when someone is logged
// in; coming back always undoes everything (each step is safe to run when there is nothing to undo).
export function inactivityEffects(stage, prev, { loggedIn }) {
  if (stage === 'inactive') return loggedIn ? ['pause', 'showOverlay'] : [];
  if (prev === 'inactive') return ['hideOverlay', 'resume', 'refreshFriends'];
  return [];
}

// A Game Hall match holds off the inactive stage while it is being played (a chess player may think
// for 5 minutes), but not once it is over: the result card can sit on screen for hours.
export function matchHoldsInactive(info) {
  return !!info && !info.over;
}
